import React, { useState, useEffect } from 'react';
import { Input } from '../../../../../components';
import style from '../group.module.scss';
import { EditIcon, DeleteIcon } from '../../../../../icons';
import { EditUtterance } from '../';
import { validate } from '../../../../../utils/validation';
import { usePermissions } from '../../../../../hooks';

type Props = {
  editUtterance: EditUtterance;
  index: number;
  utterance: string;
  closeInput: () => void;
  selectUtterance: (index: number, utterance: string) => void;
  onUtteranceEdit: (utterance: string) => void;
  deleteUtterance: (index: number) => void;
  setUtterance: () => void;
  utteranceCount: number
  visibleUtterances: string[]
};

export function Utterance(props: Props) {
  const { 
    utterance, 
    editUtterance, 
    index, 
    onUtteranceEdit, 
    closeInput, 
    selectUtterance,
    deleteUtterance,
    setUtterance,
    utteranceCount,
    visibleUtterances,
  } = props
  const [canEdit, canDelete] = usePermissions(['nlu.Edit', 'nlu.Delete']) as boolean[]

	const [error, setError] = useState("")

	function validateUtterance(utterance: string) {
		setError("");
		const result = validate("utterance", utterance, [
			{
				message: "Utterance value can't be empty",
				fn: (value: string) => value.trim().length <= 0,
			},
			{
				message: "Utterance value already exists",
				fn: (value: string) =>
					visibleUtterances.findIndex((v) => v === value.trim()) !== -1,
			},
		]);
		if (result.utterance) {
			setError(result.utterance);
		}
	}

	function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
		const value = e.currentTarget.value
		validateUtterance(value)
    onUtteranceEdit(value)
	}

  useEffect(() => {
    setError("")
  }, [editUtterance.index])

  return (
    <>
      <div className={style.utterance}>
        <p>{utterance}</p>
        <div className={style.utteranceActions}>
          {canEdit &&
            <button onClick={() => {
              selectUtterance(index, utterance)
            }}>
              <EditIcon width="14" height="14" stroke="#0466C8" />
            </button>
          }{ canDelete &&
            <button data-uttr={utteranceCount > 1} onClick={() => {
              deleteUtterance(index)
            }}><DeleteIcon width="14" height="14" stroke="#292D32" /></button>}
        </div>
      </div>
      {editUtterance.index === index && (
       <Input 
        onKeyDown={(e) => {
          if(e.keyCode === 13 && !error) {
            // If the value is not changed, just close the input
            if(e.currentTarget.value === editUtterance.initialValue) {
              closeInput()
              return
            }
            setUtterance()
          }
        }} 
        onChange={handleChange} 
        autoFocus 
        defaultValue={editUtterance.initialValue} 
        error={error}
        close={closeInput} />
      )}
    </>
  )
}
